module.exports = __webpack_public_path__ + "img/山_mountain-2.5f392d61.svg";